import { render, staticRenderFns } from "./Round.vue?vue&type=template&id=12be76a0&"
import script from "./Round.vue?vue&type=script&lang=js&"
export * from "./Round.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports